<template>
  <div class="md-layout">
    <md-card class="md-card-nav-tabs">
      <md-card-content>
        <md-tabs class="md-primary">
          <md-tab id="tab-home" md-label="Reclamaciones Cliente" v-if="tieneReclamacionesCliente()">
            <reclamaciones-cliente @on-selected="onSelectIssue"></reclamaciones-cliente>
          </md-tab>
          <md-tab
            id="tab-pages"
            md-label="Reclamaciones Consumidor"
            v-if="tieneReclamacionesConsumidor()"
          >
            <reclamaciones-consumidor @on-selected="onSelectIssue"></reclamaciones-consumidor>
          </md-tab>
        </md-tabs>
      </md-card-content>
    </md-card>

    <div class="md-layout-item md-size-100"></div>
    <div class="md-layout-item md-size-100">
      <issue-modal v-if="showIssueModal" @close="closeIssueModal" :issue="selectedIssue" />
    </div>
  </div>
</template>
<script>
import IssueModal from "./IssueModal";
import { apiServer, staticServer, florette_web } from "@/globalVars.js";
import { NavTabsCard } from "@/components";
import swal from "sweetalert2";
import ReclamacionesConsumidor from "./ReclamacionesConsumidor";
import ReclamacionesCliente from "./ReclamacionesCliente";
import ReclamacionesClienteView from "./ReclamacionesClienteView";
import { userService, empleadoService } from "@/_services";

export default {
  name: "issue-panel",
  components: {
    IssueModal,
    NavTabsCard,
    ReclamacionesConsumidor,
    ReclamacionesCliente,
  },
  props: {},
  methods: {
    tieneReclamacionesCliente() {
      return userService.tieneReclamacionesCliente(this.user);
    },
    tieneReclamacionesConsumidor() {
      return userService.tieneReclamacionesConsumidor(this.user);
    },
    onSelectIssue(issue) {
      this.selectedIssue = issue;
      if (issue != null && issue.category=='CONSUMIDOR') {
        this.$store.dispatch("reclamacion/marcarLeida", issue);
        this.$router.push(`issues/reclamacionConsumidorView/${issue._id}`);
      }
      else if(issue.category=='CLIENTE')
      {
        this.$store.dispatch("reclamacion/marcarLeida", issue);
        this.$router.push(`issues/reclamacionView/${issue._id}`);
      }
    },
    closeIssueModal() {
      this.showIssueModal = false;
    },
  },
  data() {
    return {
      showIssueModal: false,
      selectedIssue: null,
    };
  },
  mounted() {},
  watch: {
    viewIssue() {
      if (this.$store.state.reclamacion.cambioEstado.changed) {
        //this.$router.push(`issues/reclamacionView/${item._id}`);
        this.showIssueModal = true;
      }
    },
  },
  computed: {
    viewIssue() {
      return this.$store.state.reclamacion.cambioEstado;
    },
    empleado() {
      return this.$store.state.empleado.current;
    },
    user() {
      return this.$store.state.authentication.user;
    },
  },
};
</script>

<style lang="scss" scoped>
.table-primary {
  background-color: #b2dfdb;
}
.header-panel {
  padding-bottom: 20px;
}
.panel-cards {
  background-color: lightgray;
}
.user-avatar {
  border-radius: 50%;
  width: 34px;
  height: 34px;
  overflow: hidden;
  margin-top: 20px;
  margin-right: 0px;
  float: right;
}
</style>

